class TagalysPushRecommendations extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    if (this.dataset.initialized) return
    this.dataset.initialized = 'true'

    const isMobile = window.matchMedia('(max-width: 768px)').matches
    const elId = this.id.toLowerCase()
    if (
      (isMobile && !elId.includes('mobile')) ||
      (!isMobile && !elId.includes('desktop'))
    ) {
      return
    }

    if (window?.onTagalysReady && this.dataset.widgetId) {
      // eslint-disable-next-line no-undef
      onTagalysReady(() => {
        this.fetchTagalysRecommendations()
      })
    }
  }

  async fetchTagalysRecommendations () {
    try {
      const response = await this.getTagalysRecommendations()

      if (response?.products?.length > 0) {
        const cards = await this.createProductCards(response.products)

        this.buildCarousel(cards)
      }
    } catch (error) {
      this.handleError(error)
    }
  }

  getTagalysRecommendations () {
    return new Promise((resolve, reject) => {
      const productIds = this.dataset.productId?.split(',').filter(Boolean)

      window.Tagalys.APIConnector.Recommendations.call({
        params: {
          recommendationId: this.dataset.widgetId,
          count: this.dataset.limit,
          ...(productIds?.length && { productIds }),
        },
        onSuccess: (response) => resolve(response),
        onFailure: (error) => reject(error),
      })
    })
  }

  async createProductCards (products) {
    const cards = await Promise.all(
      products.map(async (product) => {
        const productUrl = `${window.Shopify.routes.root}products/${product.handle}`

        try {
          const res = await window.BAO.sectionRenderer.fetchSingle(
            'tagalys-push-product-card',
            productUrl,
          )
          const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
          const article = newDOM.querySelector('push-card')

          return article
            ? `
              <div
                class="psh-CartRecommendationsCarousel_Slide keen-slider__slide"
                data-push-cart-upsells-el="slide"
              >
                ${article.outerHTML}
              </div>`
            : ''
        } catch (error) {
          this.handleError(error)
          return 'error'
        }
      }),
    )

    return cards.join('')
  }

  buildCarousel (cards) {
    this.els.slides.element.innerHTML = cards

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.TAGALYS_CAROUSEL)
      })
    })
  }

  handleError (error) {
    console.error('Error:', error)
  }
}

if (!customElements.get('tagalys-push-recommendations')) {
  customElements.define(
    'tagalys-push-recommendations',
    TagalysPushRecommendations,
  )
}
